import * as React from 'react';
import { SVGProps } from 'react';

export const PlayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={71}
    height={71}
    fill="none"
    {...props}
  >
    <circle
      cx={35.5}
      cy={35.5}
      r={34.5}
      fill="#fff"
      fillOpacity={0.1}
      stroke="#fff"
      strokeWidth={2}
    />
    <path
      fill="#fff"
      d="M50.5 34.634a1 1 0 0 1 0 1.732L28.75 48.923a1 1 0 0 1-1.5-.866V22.943a1 1 0 0 1 1.5-.866L50.5 34.634Z"
    />
  </svg>
);
